import { MUTATION_RESPONSE_RECEIVED } from '@web-platform/shared-universal-constants/src/network';
import {
  SONAR_V3_ALPHA_CREATE_SESSION,
  SONAR_V3_CREATE_SESSION,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isSonarV3ErrorPayload } from '@web-platform/shared-universal-utils-frontend/src/helpers/isSonarErrorPayload';
import { logError } from '@web-platform/shared-universal-utils-frontend/src/helpers/logger';

import { MUTLIBOOK_OPEN_STATE_CHANGE } from '../../../../actions/detailsPanel';
import { LOCATION_CHANGED } from '../../../../actions/location';
import { isSonarV3ItineraryNotFound } from '../../flightBookingPanel/entities/flights/utils';

import type { GetExitingItineraryId } from '../../flightBookingPanel/entities/flights';
import type { ActionType } from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';
import type { ItineraryID } from '@web-platform/shared-universal-types-utils/src/utils';

type State = Record<ItineraryID, boolean>;

export const createHadErrorFPSMutationToBookingReducer =
  (getExitingId: GetExitingItineraryId) =>
  (state: State = {}, action: ActionType): State => {
    switch (action.type) {
      case MUTLIBOOK_OPEN_STATE_CHANGE: {
        // `itineraryId` is `Maybe<ID>` on the Acorn variant of this action, so guard
        // against null/undefined before keying the map to avoid `'null'`/`'undefined'` keys.
        if (!action.payload.isOpen) {
          return state;
        }
        const { itineraryId } = action.payload;
        if (!itineraryId || itineraryId === 'undefined') {
          logError({
            error: new Error('Missing itineraryId in MUTLIBOOK_OPEN_STATE_CHANGE'),
            component: 'hadErrorFPSMutationToBooking',
            message: 'Received MUTLIBOOK_OPEN_STATE_CHANGE with no itineraryId',
          });
          return state;
        }
        return { ...state, [itineraryId]: false };
      }

      case MUTATION_RESPONSE_RECEIVED:
        if (
          action.payload.type === SONAR_V3_CREATE_SESSION ||
          action.payload.type === SONAR_V3_ALPHA_CREATE_SESSION
        ) {
          const { itineraryId, itineraryToken } = action.payload.variables;
          const identifier = itineraryId || itineraryToken;
          if (!identifier || identifier === 'undefined') {
            logError({
              error: new Error('Missing itineraryId/Token in SONAR_V3_CREATE_SESSION response'),
              component: 'hadErrorFPSMutationToBooking',
              message:
                'Received SONAR_V3_CREATE_SESSION mutation response with no itineraryId or itineraryToken',
            });
            return state;
          }
          return {
            ...state,
            [String(identifier)]:
              isSonarV3ItineraryNotFound(action.payload.response) ||
              isSonarV3ErrorPayload(action.payload.response),
          };
        }

        return state;

      case LOCATION_CHANGED: {
        const { location, prevLocation } = action.payload;
        const itineraryId = getExitingId(location, prevLocation);
        if (itineraryId) {
          return { ...state, [itineraryId]: false };
        }
        return state;
      }

      default:
        return state;
    }
  };

export const get = (state: State): State => state;
